const natvieDevices = ['ios', 'android'];
import { axiomLog } from '@/lib/api.js';
const actions = {
  async nuxtServerInit({ commit }, { error, req }) {
    try {
      const currentTime = Date.now();
      const isProduction = process.env.NODE_ENV === 'production';

      if (
        typeof global !== 'undefined' &&
        (!global.nuxtInit || currentTime - global.timeStamp > 300000)
      ) {
        // global.nuxtInit = await this.$axios.get('/redis/cache/home');
        global.nuxtInit = await this.$axios.get(
          `${process.env.awsBaseUrl}/homepage`
        );

        global.timeStamp = currentTime;
        await axiomLog(this.$axios, 'init homepage', req, error);
      }

      const {
        data: { data: data }
      } = global.nuxtInit;

      commit('SET_INIT_DATA', data);
      // commit('INIT_ALL_CATEGORIES');
      commit('SET_INIT_FLAG');

      /** detect native by query param */

      let device = req.query.device;

      commit('IS_NATIVE_DEVICE', natvieDevices.includes(device));

      if (!this.$cookies.get('drushim_vue')) {
        var now = new Date();
        var nextYear = new Date().setYear(now.getFullYear() + 1);
        var cookieValue = Math.floor(Math.random() * 100) + 1;

        this.$cookies.set('drushim_vue', cookieValue, {
          path: '/',
          expires: new Date(nextYear),
          secure: isProduction,
          sameSite: isProduction ? 'None' : 'Lax'
        });
      }
    } catch (err) {
      await axiomLog(this.$axios, 'init homepage catch', req, err);
      let errorLog = new Error(err);
      console.log('errorLog', errorLog);
    }
  },
  setFeatureKeys({ commit }, keys) {
    commit('SET_FEATURES_KEYS', keys);
  }
};

export default actions;
